import { horairePasse } from './date.js';
import { display_alert, error_container, tab_allers, tab_retours } from './dom.js';


/**
 * FONCTION qui FETCH UNE URL DONNÉE AVEC DES PARAMS: elle permet de simplifier le code de toutes les autres fonction get_XXXXXXXXX en JS qui appelle l'API (voir les autres fonctions ci-dessous)
 * @param {string} url est le lien vers la page PHP qui appel la ressource de l'API.
 * @param {object} params est un objet avec les paramètres qui seront envoyés en POST
 * @returns {json} retourne le résultat au format JSON.
 */
export async function ls_fetch(url, params) {
	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams(params),
		});

		if (!response.ok) {
			throw new Error(`Erreur HTTP: ${response.status}`);
		}

		const textResponse = await response.text(); // Obtenir la réponse en texte brut
		//console.log('Réponse brute TOKEN:', textResponse);

		// Conversion en JSON
		const result = JSON.parse(textResponse); // Convertit le texte en JSON
		//console.log("result", result);
		return result;

	} catch (error) {
		console.error('Erreur lors de la récupération du TOKEN:', error);
		return null;
	}
}


/**
 * FONCTION GET_TOKEN : Permet d'obtenir un jeton de sécurité conforme au standard OAuth 2 pour les appels à l'API.
 * @param {string} cie désigne le trigramme de la compagnie.
 * @param {string} mode permet de dire si on est en dev ou prod.
 * @returns {string} retourne un token.
 */
export async function get_token(cie, mode) {
	const get_token_url = mode === 'dev' ? '../inc/get_token.php' : 'https://repo.ls-resa.fr/inc/get_token.php';
	const params = { cie, mode }; // seront envoyés en POST
	const result = await ls_fetch(get_token_url, params);
	//console.log(result.access_token);
	return result.access_token;
}


/**
 * FETCH CROISIÈRES : cette fonction ramène toutes les croisières demandées sur un interval de date.
 */
export async function fetchCroisieres(token, tab_codes_croisiere, dateDebut, dateFin, url, affiche_etapes) {
	const croisieres_to_fetch = tab_codes_croisiere.join(','); // format pour l'URL en GET
	const api_url = `${url}/${croisieres_to_fetch}?date=${dateDebut}&dateFin=${dateFin}&affichageTroncon=${affiche_etapes}`;
	//console.log('api_url → ', api_url);
	const headers = new Headers();
	headers.append('Authorization', 'Bearer ' + token);
	const requestOptions = {
		method: 'GET',
		headers: headers,
		redirect: 'follow',
	};
	try {
		//console.log(api_url)
		let response = await fetch(api_url, requestOptions);
		if (!response.ok) {
			display_alert("Aucune croisière déployée n'a été trouvée !", error_container, [tab_allers, tab_retours]);
			throw new Error(response.status);
		}
		let posts = await response.json();
		//console.log('posts at the end of fetchCrosieres()', posts);
		return posts;
	} catch (e) {
		console.error(e);
	}
}

// On rajoute une propriété dateDepart (ex. dateDepart:"20230407") avec la date SANS l'heure, pour nous permettre de rassembler les objets qui ont la même date dans des sous-ensembles.
// L'API nous renvoie des dates+Heures ISO : elles sont donc toutes ≠
export function addDateProperty(result, property) {
	let upscaled_result = result.map((obj) => {
		let value = obj.dateHeureDepart.slice(0, 10).split('-').join('');
		return Object.defineProperty(obj, property, { value: value });
	});
	return upscaled_result;
}

// REGROUPE UN TABLEAU D'OBJET SELON UNE PROPRIÉTÉ des OBJETS DU TABLEAU
// Cette fonction esrt directement reprise de la doc MDN
// SRC : https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
export function groupBy(results, propriete) {
	return results.reduce(function(acc, obj) {
		var cle = obj[propriete];
		if (!acc[cle]) {
			acc[cle] = [];
		}
		acc[cle].push(obj);
		return acc;
	}, {});
}

/**
 * FILTRE SUR LE RETOUR DE L'API
 * @param {array} result
 * @param {array} tab_codes_croisiere est un tableau de croisières
 * @returns {array} le tableau des résultats filtrés par code croisière et qui ne remonte que les croisières vendables sur Internet. On pourrait imaginer ne pas remonter les croisières complètes (pour l'instant c'est le cas)
 * On doit aussi filtrer les horaires du jour qui sont passés
 */

const gares_du_voyages = []; // Tableau ou on stocke les valeurs des gares de départs pour chaque croisière présentée
// A noter : on peut avoir des cas (ex chez CV) où on a A->B et B->C face à face dans le même afficheur.



// Dans le cas des allers retours journée, on peut se retrouver avec plusieurs départs à la même heure
// (C'est leur heure de retour qui varie)
// Dans ces cas-là, on ne souhaite ne afficher qu'un seul. 
// On boucle sur un tableau d'objets, et on ne conserve qu'un seul objet si plusieurs objets ont la même "dateHeureDepart"
function filtrerDepartsUniques(departs) {
	const departsUniques = new Map();
	// Pour chaque objet de la liste de départ du jour, on examine dateHeureDepart
	for (const depart of departs) {
		const dateHeureDepart = depart.dateHeureDepart;
		// Si dans la Map il n'existe pas encore d'entrée avec cette dateHeureDepart alors on la rajoute.
		if (!departsUniques.has(dateHeureDepart)) {
			departsUniques.set(dateHeureDepart, depart);
		}
	}
	return Array.from(departsUniques.values()); // on retransforme la Map en tableau
}




export function filterResults(result, property, condition = false) {
	// property va nous permettre de rassembler tous les horaires du même joue ensemble en les rassemblant sur la même date (sans distinction d'horaire)

	gares_du_voyages.push(result[0].gareDepart); // on valorise les gares de départ qui seront utilisées dans le titre pricipal

	//Dans un premier temps on élimine les croisières non vendables et les horaires passés
	let filtered_result = result.filter((obj) => obj.accesInternet === '1' && !horairePasse(obj.dateHeureDepart));

	console.log('filtered_result après 1er TRI', filtered_result);
	// On boucle sur le tableau des codes croisière et on filtre pour ne retenir que les croisières
	// qui en font partie.
	// Ci-dessous : il faut filtrer successivement le tableau de résultats en ne gardant à chaque fois que la croisière sélectionnée.
	// Il ne faut pas filtrer successivement en gardant pour le 2nd filtre le résultat du premier filtre sinon on se retrouve avec un tableau vide.
	// Il faut filtrer le tableau pour chaque croisière faisant partie de tab_codes_croisiere, puis concaténer les résultats.
	// On utilise pour cela un tableau intermédiaire cruise_to_keep que l'on flat
	// let cruise_to_keep = [];
	// tab_codes_croisiere.forEach((croisiere, i) => {
	// 	cruise_to_keep[i] = filtered_result.filter(
	// 		obj => obj.code === croisiere
	// 	);
	// })

	// console.log("cruise_to_keep", cruise_to_keep);

	// filtered_result = cruise_to_keep.flat();

	filtered_result = addDateProperty(filtered_result, property); // On rajoute une propriété dans l'objet qui ne servira de clé pour le grouper

	filtered_result = groupBy(filtered_result, property); // On groupe par date de départ

	//console.log("filtered_result après groupBy", filtered_result);

	filtered_result = Object.values(filtered_result); // transforme l'objet en array =>perfect dans chaque index on les départ d'une date

	// Pour une même date, quand on associe plusieurs croisières, on peut avoir un tableau avec plusieurs objets
	// (un par code croisière) avec des horaires qu'il faut trier,
	// sinon, il n'y a pas d'affichage chronologique des heures de départ.
	// On utilise la méthode Array.prototype.sort() qui permet de trier un tableau d'objet en fonction d'une propriété de ces objets
	// ici dateHeureDepart
	filtered_result = filtered_result.map(function(elt) {
		if (elt.length > 1) {
			//console.log("elt.length", elt.length);
			//console.log(elt);
			elt.sort(function(a, b) {
				return new Date(a.dateHeureDepart) - new Date(b.dateHeureDepart);
			});
		}

		return elt;
	});

	console.log("filtered_result final", filtered_result);

	if (condition) {
		filtered_result = filtered_result.map(elt => filtrerDepartsUniques(elt));
		console.log("DÉPARTS UNIQUES", filtered_result);
	}

	return filtered_result;
}







// Fonction pour afficher en titre la croisière correspondant aux horaires affichés
// En paramètre, result est le tableau déjà filtré (où chaque index est une date de départ)
export function displayGares(result) {
	if (result.length > 0) {
		return [result[0][0].gareDepart, result[0][0].gareArrivee, result[0][0].libelle];
	} else {
		display_alert("Il n'y a pas de départs progammés pour ce mois", error_container, [tab_allers, tab_retours]);
		throw new Error("Il n'y a pas de résultat pour ce mois");
	}
}

// Fonction pour afficher le titre principal de l'afficheur
// On récupère la gare de départ et la gare d'arrivée dynamiquement
export function display_afficheur_title(result, title) {
	if (typeof window.lsresa.croisiere_retour !== 'undefined') {
		title.innerHTML = `Depuis <span class="gare">${gares_du_voyages[0]}</span> ou <span class="gare">${gares_du_voyages[1]}</span>`;
	} else {
		title.innerHTML = `Depuis <span class="gare">${gares_du_voyages[0]}</span>`;
	}
}